import React from 'react';
export function TopHeaderBar() {
  return <div className="w-full bg-gradient-to-r from-blue-900/40 via-blue-800/40 to-blue-900/40 backdrop-blur-sm border-b border-blue-400/20 py-3 px-4" data-id="element-149">
      <div className="max-w-6xl mx-auto text-center" data-id="element-150">
        <p className="text-white text-sm md:text-base font-light" data-id="element-151">
          Renuévate desde el alma en solo 30 días — Incluye{' '}
          <span className="font-semibold text-yellow-300" data-id="element-152">
            2 bonos premium GRATIS
          </span>{' '}
          (valor total $64)
        </p>
      </div>
    </div>;
}